import { render, staticRenderFns } from "./add-product.vue?vue&type=template&id=d57f4a6e&scoped=true&"
import script from "./add-product.vue?vue&type=script&lang=js&"
export * from "./add-product.vue?vue&type=script&lang=js&"
import style0 from "./add-product.vue?vue&type=style&index=0&id=d57f4a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57f4a6e",
  null
  
)

export default component.exports